import { MarketRoot } from '#src/components/market/ui.tsx';

export const PageTemplate: React.FC<
  React.PropsWithChildren<{ showBack?: boolean }>
> = ({ children }) => {
  return <MarketRoot>{children}</MarketRoot>;
};
